module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cny-input"
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder
    },
    on: {
      "blur": _vm.formatDetailBudget,
      "focus": _vm.focusOnPrice
    },
    model: {
      value: (_vm.innerValue),
      callback: function($$v) {
        _vm.innerValue = $$v
      },
      expression: "innerValue"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-be6888bc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be6888bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CNYInput.vue
// module id = 1603
// module chunks = 7